import { createMakeStyles } from 'tss-react';
import { useTheme } from '@material-ui/core';

const { makeStyles } = createMakeStyles({ useTheme });

export const useStyles = makeStyles()(theme => {
  const isDarkMode = theme.palette.type === 'dark';

  return {
    asyncapiViewer: {
      // remove all surrounding whitespace
      '& .panel--center': {
        margin: '0 !important',
        padding: '0 !important',
      },
      '& section#messages': {
        margin: '0 !important',
        padding: '0 !important',
      },
      '& [class*="px-"]': {
        paddingLeft: '0 !important',
        paddingRight: '0 !important',
      },

      // hide 'Messages' title above api viewer
      '& section#messages > h2': {
        display: 'none',
      },

      // @asyncapi/react-component ships a single, hardcoded light Tailwind
      // stylesheet with no dark mode support, so the payload/headers schema
      // viewer needs its neutral colors overridden to follow the app theme.
      ...(isDarkMode && {
        '& [class~="bg-white"]': {
          backgroundColor: `${theme.palette.background.paper} !important`,
        },
        '& [class~="bg-gray-100"]': {
          backgroundColor: `${theme.palette.action.hover} !important`,
        },
        '& [class~="bg-gray-200"]': {
          backgroundColor: `${theme.palette.background.default} !important`,
        },
        '& [class~="text-gray-900"], & [class~="text-gray-700"]': {
          color: `${theme.palette.text.primary} !important`,
        },
        '& [class~="text-gray-600"], & [class~="text-gray-500"]': {
          color: `${theme.palette.text.secondary} !important`,
        },
        '& [class~="border"], & [class~="border-b"]': {
          borderColor: `${theme.palette.divider} !important`,
        },
        // the type label (string, boolean, object, ...) is teal-500
        // (#38B2AC), too dark/low-contrast against a dark background
        '& [class~="text-teal-500"]': {
          color: `${theme.palette.primary.main} !important`,
        },

        // schema descriptions are rendered as markdown via Tailwind's
        // typography (.prose) plugin, which sets its own hardcoded
        // near-black colors independent of the text-gray-* utilities above
        '& .prose, & .prose [class~="lead"]': {
          color: `${theme.palette.text.primary} !important`,
        },
        '& .prose blockquote': {
          color: `${theme.palette.text.secondary} !important`,
        },
        '& .prose a, & .prose a code': {
          color: `${theme.palette.link} !important`,
        },
        '& .prose a:hover': {
          color: `${theme.palette.linkHover} !important`,
        },
        '& .prose strong, & .prose h1, & .prose h2, & .prose h3, & .prose h4, & .prose code, & .prose thead':
          {
            color: `${theme.palette.text.primary} !important`,
          },
      }),
    },
  };
});
